webpackJsonp([222457311475995],{

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/map.26505245.png";

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(41);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _map = __webpack_require__(437);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    'section',
	    { id: 'kontakt' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'column size_100 text-center margin-top-3' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'KONTAKT'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'map',
	        style: {
	          backgroundImage: 'url(' + _map2.default + ')',
	          backgroundRepeat: 'no-repeat',
	          backgroundSize: 'cover',
	          backgroundPosition: '50% 0',
	          position: 'relative'
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column size_33 text-center' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Marek Melichar'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Selsk\xE1 25/52'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Brno 61400'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'I\u010C: 76334813'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column size_33 text-center' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Telefon:'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'tel:+420 774 982 478' },
	            '+420 774 982 478'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column size_33 text-center' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Email:'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:marek@marekmelichar.cz' },
	            'marek@marekmelichar.cz'
	          )
	        ),
	        _react2.default.createElement('div', { className: 'column size_50' })
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-kontakt-js-c2e38c32fcb0d24bf1be.js